module.exports = __webpack_public_path__ + "static/media/banner-store-img.c2ec10e0.png";